import React from "react";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import { EDITOR_MODE_OPTIONS, EDITOR_MODES } from "../../../constants/editorMode.constants";

const ACTIVE_MODE_CLASS = "bg-info-surface text-primary";
const INACTIVE_MODE_CLASS = "bg-transparent text-text-muted hover:bg-surface-muted";
const SWITCH_CLASS =
  "flex shrink-0 items-center gap-1 rounded-md border border-border bg-surface p-1 font-montserrat shadow-sm";
const MODE_BUTTON_CLASS =
  "flex h-9 items-center gap-1.5 rounded px-3 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary";
const ICON_CLASS = "h-4 w-4";

const MODE_ICONS = Object.freeze({
  [EDITOR_MODES.CANVAS]: AccountTreeOutlinedIcon,
  [EDITOR_MODES.NOTE]: NotesOutlinedIcon,
});

const getModeClass = (isSelected) =>
  [MODE_BUTTON_CLASS, isSelected ? ACTIVE_MODE_CLASS : INACTIVE_MODE_CLASS].join(" ");

const EditorModeButton = ({ isSelected, mode, onSelect }) => {
  const Icon = MODE_ICONS[mode.value] ?? NotesOutlinedIcon;

  return (
    <button
      aria-pressed={isSelected}
      className={getModeClass(isSelected)}
      onClick={() => onSelect(mode.value)}
      type="button"
    >
      <Icon className={ICON_CLASS} fontSize="small" />
      {mode.label}
    </button>
  );
};

const EditorModeSwitch = ({ selectedMode, onModeChange }) => {
  const buttons = EDITOR_MODE_OPTIONS.map((mode) => (
    <EditorModeButton
      isSelected={selectedMode === mode.value}
      key={mode.value}
      mode={mode}
      onSelect={onModeChange}
    />
  ));

  return (
    <div aria-label="Editor mode" className={SWITCH_CLASS} role="group">
      {buttons}
    </div>
  );
};

export default EditorModeSwitch;
